import L from "leaflet";

const StopIcon = (label: string) => {
  return L.divIcon({
    className: "custom-stop-label",
    html: `
        <div class="relative">
          <img 
            src="/icons/stop.png" 
            class="w-8 h-8"
            alt="Stop"
          />
          <span class="absolute -top-2 left-1/2 -translate-x-1/2 
            text-black text-xl font-bold">
            ${label}
          </span>
        </div>
      `,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -30],
  });
};

export default StopIcon;
